import {ChangeDetectionStrategy, Component, inject, Inject, input, PLATFORM_ID} from '@angular/core';
import {SearchWidgetV3ManagerService} from '../../services/search-widget-v3-manager.service';

@Component({
  selector: 'app-search-widget-v3',
  templateUrl: './search-widget-v3.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchWidgetV3Component {
  isInline = input<boolean>(false);
  private widgetManager = inject(SearchWidgetV3ManagerService);

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}
}
